export const QUIZ_OPTION_COUNT = 3 as const;

export type QuizQuestion = {
  id: string;
  prompt: string;
  options: readonly [string, string, string];
  correctIndex: 0 | 1 | 2;
  rutubeUrl?: string;
};

/** Банк вопросов квиза (`.dev/quiz-questions.md`). */
export const QUIZ_QUESTIONS: readonly QuizQuestion[] = [
  {
    id: 'quiz_01',
    prompt: 'Чей танец чуть не разрушил мир Шу?',
    options: ['Луна Му', 'Туччи', 'Сол'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/99254714425f7f7ba57f22ab7e801596/',
  },
  {
    id: 'quiz_02',
    prompt: 'Кто Валл по гороскопу?',
    options: ['Рыбы', 'Кит', 'Креветка'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/f279e1a0e8a082903dde0c43d54c5ea2/',
  },
  {
    id: 'quiz_03',
    prompt: 'Какая страшилка существует в мире Шу?',
    options: ['Посылка на колёсиках', 'Чёрная посылка', 'Посылка с глазами'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/989c4025d792214adb9b642c325b8357/',
  },
  {
    id: 'quiz_04',
    prompt: 'Кто гениальный изобретатель мира Шу?',
    options: ['Эдди', 'Уфо', 'Рок'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/bc0ed37199707fe2797d3acec7378619/',
  },
  {
    id: 'quiz_05',
    prompt: 'Кто главный поэт мира Шу?',
    options: ['Красный ледник Серж', 'Завод Фактор', 'Дядюшка Вилли'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/5d1a88aefe91a2f44fe5e0fb36427c98/',
  },
  {
    id: 'quiz_06',
    prompt:
      'В одной из ранних серий звучит старое название «Улётной доставки». Клауди обещает, что заказ выполнит…',
    options: ['Доставка молнии', 'Улётный экспресс', 'Я — молния'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/abf1338b8f1cc9d2c1ccee3aa3daffee/',
  },
  {
    id: 'quiz_07',
    prompt:
      'По словам авторов идеи сериала «Улётная доставка», Клауди — это героиня классического стихотворения. Какого?',
    options: ['«Туча» А. С. Пушкин', '«Тучи с ожерёба» С. А. Есенин', '«Утёс» М.Ю. Лермонтов'],
    correctIndex: 2,
  },
  {
    id: 'quiz_08',
    prompt: 'У Эдди и Рока был старый символ дружбы. Это…',
    options: ['Камень', 'Палка', 'Жвачка'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/2411cdafed9c055d3ed82db223fe2cdf/',
  },
  {
    id: 'quiz_09',
    prompt: 'Никто не видел, как выглядит маленький племянник Моны. Но у него точно есть…',
    options: ['Русалочий хвост', 'Рога', 'Щупальце'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/5b195baa460f366e4080b27fc4e50a86/',
  },
  {
    id: 'quiz_10',
    prompt: 'Какой подарок Валл точно не хотел себе?',
    options: ['Уточка для ванной', 'Пипидастр', 'Кактус'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/02df7943b016112caee9b86ccc73e06c/',
  },
  {
    id: 'quiz_11',
    prompt: 'Что Рок изобрёл в подарок для Баффи и Буффи?',
    options: ['Машину времени', 'Сахарную вату', 'Самокат'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/bc0ed37199707fe2797d3acec7378619/',
  },
  {
    id: 'quiz_12',
    prompt: 'Китёнок Валл разучился читать, когда прочёл в энциклопедии, что киты не летают.',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/946cf10daf605a7067ae1f20d41e9742/',
  },
  {
    id: 'quiz_13',
    prompt: 'Туччи не любит Новый год, потому что всё слишком ЯРКОе.',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/b414df90383261a0372958ebd8f09e6f/',
  },
  {
    id: 'quiz_14',
    prompt: 'Музыканты Дракочи и Йети ненавидят играть вместе.',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/abf1338b8f1cc9d2c1ccee3aa3daffee/',
  },
  {
    id: 'quiz_15',
    prompt: 'У русалки Моны и у тучки Клауди есть общее увлечение. Это…',
    options: ['Слушать металл', 'Принимать расслабляющую ванну', 'Летать'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/5ac22fedead4e15de9eb9b4fe780cf61/',
  },
  {
    id: 'quiz_16',
    prompt: 'Сколько окон может разбить Эдди за одну доставку?',
    options: ['Одно', 'Два', 'Три'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/5950ea267a21e6623fe3669f2b6f2a69/',
  },
  {
    id: 'quiz_17',
    prompt: 'Плохая идея была научить Обсерваторию Розу…',
    options: ['Отправлять голосовые сообщения', 'Выходить в интернет', 'Снимать вертикальные видео'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/3fd579fe3b67792d7e356566d760756f/',
  },
  {
    id: 'quiz_18',
    prompt: 'Хулиган Огонёк кидается во всех…',
    options: ['Снежинками', 'Сгущёнкой', 'Смешинками'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/53def96e5c1a03e55d03989a263d14f9/',
  },
  {
    id: 'quiz_19',
    prompt: 'В качестве питомца Клауди завела себе китёнка!',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/08ee402e8c083d973213184b02d83552/',
  },
  {
    id: 'quiz_20',
    prompt: 'Ледник Серж — талантливая личность. Но одно из увлечений точно обошло его стороной.',
    options: ['Стихи', 'Гипноз', 'Варить кофе'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/5d1a88aefe91a2f44fe5e0fb36427c98/',
  },
  {
    id: 'quiz_21',
    prompt: 'Единственный ученик школы Улётной доставки, который не может летать самостоятельно.',
    options: ['Рок', 'Уфо', 'Дядюшка Вилли'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/9ef79016058afda9e4c1d1744e2ae417/',
  },
  {
    id: 'quiz_22',
    prompt: 'Туччи, Клауди и Эдди могут поливать землю дождём.',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/5fd6bc0db69bfbc6328a68bf3d14e4ba/',
  },
  {
    id: 'quiz_23',
    prompt: 'У мяу-лимонада есть волшебный эффект. От него…',
    options: ['Вырастает хвост', 'Появляются кошачьи ушки', 'Тело покрывается шерстью'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/9ec46228f51617c74202bd214f207ae3/',
  },
  {
    id: 'quiz_24',
    prompt: 'Как сказать на языке Уфо «Капитан Уточка попал в беду»?',
    options: ['Капитан Уточка МИРИМИСИ', 'Капитан Уточка ПОПАДУЛИ', 'Капитан Уточка АБОСАРИ МОКУ'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/1bf9c630af72363fd6738a3881b23699/',
  },
  {
    id: 'quiz_25',
    prompt: 'Фирменная фраза Туччи.',
    options: ['Всё тучком', 'Порядочек!', 'Элементарно'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/942f2f2cbbc069f45391e1fe5e77867c/',
  },
  {
    id: 'quiz_26',
    prompt: 'Уфо влюблена в…',
    options: ['Туччи', 'Солнце Сола', 'Эдди'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/454271593ae954e13e433c5c94c691d5/',
  },
  {
    id: 'quiz_27',
    prompt: 'Единственный раз, когда все потеряли Фактора, он просто…',
    options: ['Стал невидимкой', 'Ушёл в отпуск', 'Не выходил в интернет'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/3f22cc692a5961018b96a84e753c82f2/',
  },
  {
    id: 'quiz_28',
    prompt: 'В мире гигантов вместо птичек…',
    options: ['Летающие тарелки', 'Птеродактили', 'Вертолётики'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/0e6522ae6949edd2828b1a60489a8fc4/',
  },
  {
    id: 'quiz_29',
    prompt: 'Кто самый старший в семье тучек?',
    options: ['Туччи', 'Клауди', 'Эдди'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/adfeba4633e5797b9be44c12ba7b8946/',
  },
  {
    id: 'quiz_30',
    prompt: 'По каким украшениям НЕ сходил с ума мир Шу?',
    options: ['Из карамели', 'Изо льда', 'Из фольги'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/4d7dce2ad5143b4c2a79c03cb054398e/',
  },
  {
    id: 'quiz_31',
    prompt: 'Кто из курьеров решил открыть свою СОБСТВЕННУЮ доставку?',
    options: ['Клауди', 'Валл', 'Рок'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/40c90b8a57dd3c7720828f538349ce31/',
  },
  {
    id: 'quiz_32',
    prompt: 'Когда дом с призраками становится злым?',
    options: ['После полуночи', 'Когда голоден', 'В темноте'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/7115be22fa6f7f7c934b6a62bc35f2d6/',
  },
  {
    id: 'quiz_33',
    prompt: 'У Обсерватории Розы есть родственник. Это…',
    options: ['Завод Фактор', 'Дом с призраками', 'Луна Му'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/1b4208179f98f9361a02b43cfbf92e5a/',
  },
  {
    id: 'quiz_34',
    prompt: 'Какой гигант разослал всему миру Шу своих маленьких двойников?',
    options: ['Дядюшка Вилли', 'Ледник Серж', 'Йети'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/5e341cdc1e9ba5e76e829f832efdf582/',
  },
  {
    id: 'quiz_35',
    prompt: 'Кто спит большую часть времени?',
    options: ['Луна Му', 'Правители Свами', 'Дядюшка Вилли'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/ae62cddd0a389de8e9570ace13b7cad4/',
  },
  {
    id: 'quiz_36',
    prompt: 'Кто поёт хуже всех в мире Шу?',
    options: ['Валл', 'Луна Му', 'Призраки'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/efbff8506b3d69a4d7dcad905c032954/',
  },
  {
    id: 'quiz_37',
    prompt: 'Кто работает от солнечной батареи?',
    options: ['Солнце Сол', 'Завод Фактор', 'Обсерватория Роза'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/f7a984aa59e5b062bc8089d075dda08b/',
  },
  {
    id: 'quiz_38',
    prompt: 'Родители Валла снимаются в кино.',
    options: ['Правда', 'Неправда', 'Сложно сказать'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/666ded37f4b543d87b2391729ade550b/',
  },
  {
    id: 'quiz_39',
    prompt: 'Единственный, кто понимает язык Уфо — это…',
    options: ['Тётушка Кототуча', 'Огонёк', 'Эдди'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/5fb6bfd4720c0a8c44ae59aa9fcba85b/',
  },
  {
    id: 'quiz_40',
    prompt: 'Один из важнейших признаков того, что вулкан стал взрослым — это…',
    options: ['Усы', 'Брови', 'Ноги'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/422034014dd33fe45523d4231c7de53e/',
  },
  {
    id: 'quiz_41',
    prompt: 'Как зовут зелёного друга Розы?',
    options: ['Дональд', 'Рональд', 'Макдональд'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/33b5699936315ff9c34f06c6ebf48e47/',
  },
  {
    id: 'quiz_42',
    prompt: 'Самая первая в мире Шу посылка предназначалась…',
    options: ['Зелёной девочке', 'Карапузу Йети', 'Мальчику В.'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/3283661870230b249ce7401422d8d770/',
  },
  {
    id: 'quiz_43',
    prompt: 'У тучек есть родная Тётя по имени…',
    options: ['Кототуча', 'Чуча', 'Тутуча'],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/47dd77fcea8223ddfdb147b77278bc76/',
  },
  {
    id: 'quiz_44',
    prompt: 'Весь мир Шу ими населён. Но обычно их не видно. Про кого речь?',
    options: ['Комары', 'Люди', 'Призраки курьеров'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/f830d10d54f23d2b321b5f62c50b8adf/',
  },
  {
    id: 'quiz_45',
    prompt: 'Если держать посылки в грязи, они могут…',
    options: ['Прорасти', 'Состариться', 'Одичать'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/e61118f2f4cc42d26b3eeccb7498d1b3/',
  },
  {
    id: 'quiz_46',
    prompt: 'Сколько звёзд на небе мира Шу?',
    options: [
      'Четыреста пятьдесят ундецеллионов восемьсот тучкаллионов миллиардов звездаллионов двадцать одна',
      'Невозможно сосчитать',
      'Четырнадцать',
    ],
    correctIndex: 0,
    rutubeUrl: 'https://rutube.ru/video/b041d224c0808462b4be9b26c256ca90/',
  },
  {
    id: 'quiz_47',
    prompt: 'Своей любви к какому музыкальному инструменту так стеснялся Туччи?',
    options: ['Бубен', 'Волынка', 'Треугольник'],
    correctIndex: 1,
    rutubeUrl: 'https://rutube.ru/video/681bb7304c056501a91229852b4962ce/',
  },
  {
    id: 'quiz_48',
    prompt: 'При какой из этих эмоций тучка НЕ бьётся молнией?',
    options: ['Смех', 'Злость', 'Удовольствие'],
    correctIndex: 2,
    rutubeUrl: 'https://rutube.ru/video/92d6e3ca19959036ff13ba5687f0a34a/',
  },
] as const;

export function getQuizQuestionById(id: string): QuizQuestion | undefined {
  return QUIZ_QUESTIONS.find((q) => q.id === id);
}
